var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheckRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C5.41563 0 5.75 0.334375 5.75 0.75V2H10.25V0.75C10.25 0.334375 10.5844 0 11 0C11.4156 0 11.75 0.334375 11.75 0.75V2H13C14.1031 2 15 2.89688 15 4V4.5V6V14C15 15.1031 14.1031 16 13 16H3C1.89688 16 1 15.1031 1 14V6V4.5V4C1 2.89688 1.89688 2 3 2H4.25V0.75C4.25 0.334375 4.58437 0 5 0ZM13.5 6H2.5V14C2.5 14.275 2.725 14.5 3 14.5H13C13.275 14.5 13.5 14.275 13.5 14V6ZM11.2812 9.28125L7.78125 12.7812C7.4875 13.075 7.0125 13.075 6.72188 12.7812L4.72187 10.7812C4.42812 10.4875 4.42812 10.0125 4.72187 9.72188C5.01562 9.43125 5.49062 9.42813 5.78125 9.72188L7.25 11.1906L10.2188 8.22188C10.5125 7.92813 10.9875 7.92813 11.2781 8.22188C11.5687 8.51563 11.5719 8.99062 11.2781 9.28125H11.2812Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheckRegular);
export default __webpack_public_path__ + "static/media/calendar-check-regular.0f6cade5c1315aaefbedb5b5d80eebaf.svg";
export { ForwardRef as ReactComponent };